import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

interface DropdownChangeConfirmDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  ministerCount: number;
}

/**
 * Organism: Confirmation dialog for dropdown changes that would reset minister selection
 */
export function DropdownChangeConfirmDialog({
  open,
  onOpenChange,
  onConfirm,
  ministerCount,
}: DropdownChangeConfirmDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>¿Confirmar cambio?</AlertDialogTitle>
          <AlertDialogDescription className="space-y-2">
            <p>
              Tiene <span className="font-semibold">{ministerCount} ministro{ministerCount !== 1 ? 's' : ''} seleccionado{ministerCount !== 1 ? 's' : ''}</span>.
            </p>
            <p>
              Al cambiar el distrito o región, se restablecerá la selección de ministros y deberá volver a seleccionarlos.
            </p>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancelar</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm}>
            Continuar con el cambio
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
